import React, { useEffect } from "react";
import { Form, FormElement } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import AlertBox from "../../../components/common/AlertBox";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllJournalRegisterReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearJournalRegisterReportList } from "../reportsSlice";
import { formatIndianNumber } from "../../../_helper/helper";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { sumBy } from "lodash";

const JournalRegisterReportNew: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("journalregisterreportState") || "{}"
  );
  const initialValues = JSON.parse(JSON.stringify(state.initialValues));
  const gridRef = React.useRef<any>(null);

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
   
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .salesmanwisereport-print-break{
          page-break-before: always;
          }
      }
     
    `;
    document.head.appendChild(style);
  };

  const JournalRegisterReportList = useAppSelector(
    (state) => state.reports.JournalRegisterReportList
  );

  const loading = useAppSelector((state) => state.reports.loading);

  const fetchReport = async () => {
    const payload = {
      from_date: state?.from_date,
      to_date: state?.to_date,
    };
    const res = await dispatch(getAllJournalRegisterReport(payload));

    setPrintStyles();
    if (res.meta.requestStatus === "fulfilled") {
      setTimeout(() => {
        // window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("journalregisterreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearJournalRegisterReportList());
    };
  }, []);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {JournalRegisterReportList && JournalRegisterReportList.length ? (
        <Form
          initialValues={initialValues}
          render={() => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <GridLayoutItem>
                    <ButtonWithLoading
                      buttonStyle={{
                        position: "fixed",
                        right: 0,
                        top: 0,
                        zIndex: 100,
                      }}
                      label={"Print"}
                      className="no-visible-print-btn"
                      type="button"
                      onClick={() => window.print()}
                    />

                    <div style={{ textAlign: "center" }}>
                      <h4
                        style={{
                          margin: 0,
                          textAlign: "center",
                          fontWeight: "900",
                        }}
                      >
                        HARIHAR FOODS PVT LTD.
                      </h4>
                      <p style={{ margin: 0 }}>
                        519/1, PHASE IV, VATVA, GIDC, AHMEDABAD-382445
                      </p>
                      <h6
                        style={{
                          margin: 0,
                          textAlign: "center",
                          fontWeight: "900",
                        }}
                      >
                        Journal Register{" "}
                      </h6>
                      <p style={{ margin: 0 }}>
                        {state.from_date &&
                          state.to_date &&
                          `( ${moment(state.from_date, "YYYY-MM-DD").format(
                            "DD/MM/YYYY"
                          )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                            "DD/MM/YYYY"
                          )} )`}
                      </p>
                    </div>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <table
                      cellSpacing={1}
                      className={`table contra-register-report-table`}
                    >
                      <thead>
                        <tr
                          className="text-center fw-600"
                          style={{
                            fontSize: 12,
                          }}
                        >
                          <th style={{ minWidth: 100 }}>Date</th>

                          <th style={{ minWidth: 300, textAlign: "start" }}>
                            Particulars
                          </th>

                          <th style={{ minWidth: 150 }}>Voucher Type</th>

                          <th style={{ minWidth: 150, textAlign: "end" }}>
                            Voucher No
                          </th>

                          <th style={{ minWidth: 120, textAlign: "end" }}>
                            Debit
                          </th>
                          <th style={{ minWidth: 120, textAlign: "end" }}>
                            Credit
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {JournalRegisterReportList.map(
                          (item: any, rowIndex: number) => {
                            return (
                              <>
                                {/* <tr key={rowIndex}>
                                  <td style={{ paddingTop: "10px" }}>
                                    {item?.journal_voucher_date}
                                  </td>
                                  <td style={{ paddingTop: "10px" }}>
                                    <strong>{item?.ledger_name}</strong>{" "}
                                  </td>

                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-center"
                                  >
                                    <strong>{item?.voucher_type}</strong>
                                  </td>

                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-end"
                                  >
                                    {item?.journal_voucher_no_string}
                                  </td>
                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-end"
                                  >
                                    <strong>
                                      {formatIndianNumber(
                                        item?.journal_voucher_total_amount || 0
                                      )}
                                    </strong>
                                  </td>
                                  <td
                                    style={{ paddingTop: "10px" }}
                                    className="text-end"
                                  ></td>
                                </tr> */}
                                {item?.journal_voucher_register?.map(
                                  (entry: any, innerIndex: number) => (
                                    <>
                                      <tr key={innerIndex}>
                                        <td>
                                          {innerIndex === 0 &&
                                            item?.journal_voucher_date}
                                        </td>
                                        <td>{entry?.ledger_name}</td>
                                        <td className="text-center">
                                          {innerIndex === 0 &&
                                            item?.voucher_type}
                                        </td>
                                        <td className="text-center">
                                          {innerIndex === 0 &&
                                            item?.journal_voucher_no_string}
                                        </td>
                                        <td className="text-end">
                                          <strong>
                                            {entry?.debit_credit === "Debit" &&
                                              formatIndianNumber(
                                                entry?.amount || 0
                                              )}
                                          </strong>
                                        </td>
                                        <td className="text-end">
                                          <strong>
                                            {entry?.debit_credit === "Credit" &&
                                              formatIndianNumber(
                                                entry?.amount || 0
                                              )}
                                          </strong>
                                        </td>
                                      </tr>
                                      {innerIndex ===
                                        item?.journal_voucher_register?.length -
                                          1 &&
                                        rowIndex !==
                                          JournalRegisterReportList?.length -
                                            1 && (
                                          <tr>
                                            <td colSpan={7}>
                                              <hr className="m-1" />
                                            </td>
                                          </tr>
                                        )}
                                    </>
                                  )
                                )}

                                {rowIndex ===
                                  JournalRegisterReportList?.length - 1 && (
                                  <tr
                                    style={{
                                      borderTop: "1px solid grey",
                                      borderBottom: "1px solid grey",
                                    }}
                                  >
                                    <td
                                      colSpan={5}
                                      style={{ padding: "5px 0" }}
                                      className="text-end"
                                    >
                                      <strong> Total : </strong>
                                    </td>
                                    <td
                                      className="text-end"
                                      style={{ padding: "5px 0" }}
                                    >
                                      <strong>
                                        {formatIndianNumber(
                                          sumBy(
                                            JournalRegisterReportList,
                                            "journal_voucher_total_amount"
                                          ) || 0
                                        )}
                                      </strong>
                                    </td>
                                  </tr>
                                )}
                              </>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default JournalRegisterReportNew;
